import { gql } from '@apollo/client';

// Query to get homeowner matching profile
export const GET_HOMEOWNER_MATCHING_PROFILE = gql`
  query GetHomeownerMatchingProfile($homeOwnerId: String!) {
    getHomeOwnerMatchingProfile(homeOwnerId: $homeOwnerId) {
      _id
      homeOwnerId
      stepCompletion {
        personalityCompleted
        styleCompleted
        projectCompleted
        preferenceCompleted
        prioritiesCompleted
      }
      personalityType
      projectType {
        projectType
        projectAddress {
          id
          streetAddress1
          streetAddress2
          city
          state
          zipCode
        }
        designItems
        specialNeeds
        conceptPresentation
      }
      priorities {
        order
      }
      preferences {
        budgetRange
        billingMethods
        wantsFinancing
        partnershipStyle
        designerRole
        skillRankings
        acquisitionPreference
        designerGenderPreference
        designerPetPreference
        lgbtqFriendly
        womenOwnedFirm
        minorityOwnedPreference
        samePolitics
        politicalAffiliation
        sameAgeRangePreference
        desiredAgeRange
        hasChildrenPreference
        experiencePreference
        hireReason
        hireLikelihood
      }
      homeOwnerStyles {
        homeOwnerStyle
        favoriteLook
        selectedStyles
        selectedImages {
          style
          imageIndex
          src
        }
        matchupResults {
          style1
          style2
          winner
        }
        finalSelections {
          style
          imageIndex
          src
        }
      }
    }
  }
`;

// Query to get homeowner step status (determines which step to show)
export const GET_HOMEOWNER_STEP_STATUS = gql`
  query GetHomeownerStepStatus($homeOwnerId: String!) {
    getHomeownerStepStatus(homeOwnerId: $homeOwnerId) {
      profileExists
      currentStep
      completedSteps
      nextStep
      profile {
        _id
        homeOwnerId
        stepCompletion {
          personalityCompleted
          styleCompleted
          projectCompleted
          preferenceCompleted
          prioritiesCompleted
        }
        personalityType
      }
    }
  }
`;

// Mutation to create homeowner matching profile
export const CREATE_HOMEOWNER_MATCHING_PROFILE = gql`
  mutation CreateHomeownerMatchingProfile(
    $homeOwnerId: String!
    $stepCompletion: HomeOwnerMatchingProfileStepCompletionInput
    $personalityType: PersonalityType
    $projectType: HomeOwnerMatchingProfileProjectInput
    $priorities: HomeOwnerPrioritiesInput
    $preferences: HomeOwnerMatchingProfilePreferenceInput
    $homeOwnerStyles: homeOwnerInterestedStylesInput
  ) {
    createHomeOwnerMatchingProfile(
      homeOwnerId: $homeOwnerId
      stepCompletion: $stepCompletion
      personalityType: $personalityType
      projectType: $projectType
      priorities: $priorities
      preferences: $preferences
      homeOwnerStyles: $homeOwnerStyles
    )
  }
`;

// Mutation to update homeowner matching profile
export const UPDATE_HOMEOWNER_MATCHING_PROFILE = gql`
  mutation UpdateHomeownerMatchingProfile(
    $_id: ID!
    $stepCompletion: HomeOwnerMatchingProfileStepCompletionInput
    $personalityType: PersonalityType
    $projectType: HomeOwnerMatchingProfileProjectInput
    $priorities: HomeOwnerPrioritiesInput
    $preferences: HomeOwnerMatchingProfilePreferenceInput
    $homeOwnerStyles: homeOwnerInterestedStylesInput
  ) {
    updateHomeOwnerMatchingProfile(
      _id: $_id
      stepCompletion: $stepCompletion
      personalityType: $personalityType
      projectType: $projectType
      priorities: $priorities
      preferences: $preferences
      homeOwnerStyles: $homeOwnerStyles
    )
  }
`;
